import type { ColSpanParams, ICellRendererParams } from "../molecules/Grid";

const createColumnBelongsToTheGroup =
    (groupColId: string) => (colId: string) => {
        return colId === groupColId || colId.startsWith(`${groupColId}-`);
    };

export const createCalculateColSpanForMergingDuplicatedColumnsCellsWithSameValue =

        ({
            relyOnGridApiExpandedValue,
        }: {
            relyOnGridApiExpandedValue: boolean;
        }) =>
        <T extends { type: string }>(
            params: ColSpanParams<T> | ICellRendererParams<T>,
        ) => {
            const row = params.data;
            if (!row) return 1;

            const column = params.column;
            if (!column) return 1;

            const columnGroup = column.getParent();
            if (!columnGroup) return 1;

            if (relyOnGridApiExpandedValue) {
                const isGroupExpanded = columnGroup.isExpanded();
                if (!isGroupExpanded) return 1;
            }

            const rowType = row.type;
            const TYPES_ALLOWED_FOR_COLSPAN = ["SUBSECTION", "SECTION", "TYPE"];
            const isRowAllowedForColSpan =
                TYPES_ALLOWED_FOR_COLSPAN.includes(rowType);
            if (!isRowAllowedForColSpan) return 1;

            const groupColId = column.getColId();
            const columnBelongsToCurrentGroup =
                createColumnBelongsToTheGroup(groupColId);
            const cellValuesInCurrentGroup = Object.entries(row)
                .filter(([colId]) => columnBelongsToCurrentGroup(colId))
                .map(([, value]) => {
                    return value;
                });
            const allCellValuesInCurrentGroupAreTheSame =
                cellValuesInCurrentGroup.every(
                    (value, _, arr) => value === arr[0],
                );
            if (!allCellValuesInCurrentGroupAreTheSame) return 1;

            return cellValuesInCurrentGroup.length;
        };

export const createShouldMergeDuplicatedColumnsCellsWithSameValue =
    ({ relyOnGridApiExpandedValue }: { relyOnGridApiExpandedValue: boolean }) =>
    <T extends { type: string }>(
        params: ColSpanParams<T> | ICellRendererParams<T>,
    ) => {
        return (
            createCalculateColSpanForMergingDuplicatedColumnsCellsWithSameValue(
                {
                    relyOnGridApiExpandedValue,
                },
            )(params) > 1
        );
    };
